<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">消息推送管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>消息类型与通道</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="toolbar">
        <el-select
          v-model="filterMessageSource"
          class="filter-item"
          size="small"
          clearable
          filterable
          placeholder="消息类型"
          style="width: 240px"
          @change="fetchList"
        >
          <el-option
            v-for="m in messageSourceOptions"
            :key="m.code"
            :label="m.labelZh"
            :value="m.code"
          />
        </el-select>
        <el-button size="small" @click="onReset">重置</el-button>
        <el-button
          v-if="canBindAdd"
          type="primary"
          size="small"
          @click="openCreate"
        >
          新增绑定
        </el-button>
      </div>
      <el-table :data="rows" border size="small" style="width: 100%">
        <el-table-column label="序号" width="72">
          <template slot-scope="scope">
            {{ (page - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="通道名称" width="120" prop="channelCode" show-overflow-tooltip />
        <el-table-column label="消息类型" min-width="160" prop="messageSourceLabelZh" />
        <el-table-column label="模版" min-width="160" show-overflow-tooltip prop="notifyTemplate" />
        <el-table-column label="通道" min-width="260">
          <template slot-scope="scope">
            <div>{{ scope.row.channelLabelZh }}</div>
            <div v-if="scope.row.msgUse" class="sub">{{ scope.row.msgUse }}</div>
          </template>
        </el-table-column>
        <el-table-column label="通知" width="88">
          <template slot-scope="scope">
            {{ scope.row.notifyType === 1 ? '内部' : '外部' }}
          </template>
        </el-table-column>
        <el-table-column label="启用" width="90">
          <template slot-scope="scope">
            <el-switch
              v-if="canBindToggle"
              :value="bindingEnabledOn(scope.row)"
              active-color="#13ce66"
              @change="(v) => onBindingEnabledChange(scope.row, v)"
            />
            <span v-else>{{ bindingEnabledOn(scope.row) ? '开' : '关' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="canBindView" type="text" size="small" @click="openDetail(scope.row)">
              详情
            </el-button>
            <el-button v-if="canBindEdit" type="text" size="small" @click="openEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="canBindDelete"
              type="text"
              size="small"
              style="color:#f56c6c"
              @click="confirmDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        :page-sizes="[10, 20, 50]"
        @size-change="onSizeChange"
        @current-change="fetchList"
      />
    </el-card>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="620px"
      :close-on-click-modal="false"
      @closed="resetForm"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="120px"
        size="small"
        :disabled="isDetail"
      >
        <el-form-item label="通道名称" prop="channelName">
          <el-select
            v-model="form.channelName"
            placeholder="通道种类（与平台 channel_name 一致）"
            filterable
            clearable
            style="width: 100%"
            :disabled="isDetail"
            @change="onChannelKindChange"
          >
            <el-option
              v-for="k in channelKindOptions"
              :key="'kind' + k.code"
              :label="k.labelZh"
              :value="k.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="消息类型" prop="messageSource">
          <el-select v-model="form.messageSource" placeholder="请选择" filterable style="width: 100%">
            <el-option
              v-for="m in messageSourceOptions"
              :key="'fm' + m.code"
              :label="m.labelZh"
              :value="m.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="通知类型" prop="notifyType">
          <el-select v-model="form.notifyType" placeholder="请选择" style="width: 100%">
            <el-option :value="0" label="外部（发送记录入库）" />
            <el-option :value="1" label="内部（不入库）" />
          </el-select>
        </el-form-item>
        <el-form-item label="消息通道" prop="channelId">
          <el-select
            v-model="form.channelId"
            :placeholder="tenantChannelPlaceholder"
            filterable
            style="width: 100%"
            :disabled="isDetail || tenantChannelRowDisabled"
          >
            <el-option v-for="c in channelPickOptions" :key="c.id" :label="c.displayLabel" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="模版">
          <div class="tpl-row">
            <el-input
              v-model="form.notifyTemplate"
              type="textarea"
              :rows="3"
              maxlength="2048"
              show-word-limit
              placeholder="选填。通知类型=内部 时要填"
            />
            <el-button
              v-if="canSuggestSpotPlatformTemplate"
              size="small"
              class="tpl-sync"
              :loading="spotSuggestLoading"
              @click="pullSpotTemplate(true)"
              >填入平台模版</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.enabled" active-text="是" inactive-text="否" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">{{ isDetail ? '关 闭' : '取消' }}</el-button>
        <el-button
          v-if="!isDetail"
          type="primary"
          size="small"
          :loading="submitLoading"
          @click="submitForm"
        >
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { hasPerm } from 'common/permission';
import api from './api';

function emptyForm() {
  return {
    id: null,
    channelName: '',
    messageSource: '',
    notifyType: 0,
    channelId: null,
    notifyTemplate: '',
    enabled: true,
  };
}

export default {
  name: 'TenantMsgBindPage',
  data() {
    return {
      filterMessageSource: '',
      messageSourceOptions: [],
      channelKindOptions: [],
      channelPickOptions: [],
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      isDetail: false,
      form: emptyForm(),
      formRules: {
        channelName: [{ required: true, message: '请选择通道名称', trigger: 'change' }],
        messageSource: [{ required: true, message: '请选择消息类型', trigger: 'change' }],
        notifyType: [
          {
            validator: (rule, value, callback) => {
              if (value !== 0 && value !== 1) {
                callback(new Error('请选择通知类型'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        channelId: [{ required: true, message: '请选择通道', trigger: 'change' }],
      },
      submitLoading: false,
      spotSuggestLoading: false,
      spotSuggestTimer: null,
    };
  },
  computed: {
    ...mapState(['userInfo']),
    /** 仅存对应按钮菜单权限；仅靠页面 view 不能写接口也无法点按钮 */
    canBindAdd() {
      return hasPerm(this.userInfo || {}, 'tenant:msg_push_bind:add');
    },
    canBindEdit() {
      return hasPerm(this.userInfo || {}, 'tenant:msg_push_bind:edit');
    },
    canBindDelete() {
      return hasPerm(this.userInfo || {}, 'tenant:msg_push_bind:delete');
    },
    canBindToggle() {
      return hasPerm(this.userInfo || {}, 'tenant:msg_push_bind:toggle');
    },
    canBindView() {
      return hasPerm(this.userInfo || {}, 'tenant:msg_push_bind:view');
    },
    /** 同步平台模版 GET 挂在 add/edit 按钮权限上（无单独 spot_tpl） */
    canSuggestSpotPlatformTemplate() {
      if (this.isDetail) return false;
      return (
        (!this.isEdit && this.canBindAdd) ||
        (this.isEdit && this.canBindEdit)
      );
    },
    tenantChannelRowDisabled() {
      const cn = this.form.channelName;
      return cn === null || cn === undefined || String(cn).trim() === '';
    },
    tenantChannelPlaceholder() {
      if (this.isDetail) return '';
      if (this.tenantChannelRowDisabled) {
        return '请先选择通道名称';
      }
      return '请选择该通道名称下的具体记录';
    },
  },
  watch: {
    'form.channelName'() {
      this.scheduleSpotSuggest(false);
    },
    'form.messageSource'() {
      this.scheduleSpotSuggest(false);
    },
    'form.notifyType'() {
      this.scheduleSpotSuggest(false);
    },
    'form.channelId'() {
      this.scheduleSpotSuggest(false);
    },
  },
  beforeDestroy() {
    if (this.spotSuggestTimer) clearTimeout(this.spotSuggestTimer);
  },
  created() {
    this.loadOptions();
    this.fetchList();
  },
  methods: {
    async loadOptions() {
      try {
        const [sources, kinds] = await Promise.all([api.messageSourceOptions(), api.types()]);
        this.messageSourceOptions = (sources && sources.data) || [];
        this.channelKindOptions = (kinds && kinds.data) || [];
      } catch (e) {
        /* empty */
      }
      await this.reloadChannelPickOptions();
    },
    async reloadChannelPickOptions() {
      if (!this.dialogVisible) {
        this.channelPickOptions = [];
        return;
      }
      const cn = this.form.channelName ? String(this.form.channelName).trim() : '';
      if (!cn) {
        this.channelPickOptions = [];
        return;
      }
      try {
        const res = await api.enabledChannels(cn);
        this.channelPickOptions = (res && res.data) || [];
      } catch (e) {
        this.channelPickOptions = [];
      }
    },
    onChannelKindChange() {
      this.form.channelId = null;
      if (this.dialogVisible) {
        this.reloadChannelPickOptions();
      }
    },
    async fetchList() {
      try {
        const res = await api.page({
          page: this.page,
          size: this.pageSize,
          messageSource: this.filterMessageSource || undefined,
        });
        const pr = res && res.data ? res.data : {};
        this.rows = pr.items || [];
        this.total = pr.total || 0;
      } catch (e) {
        /* empty */
      }
    },
    onSizeChange(s) {
      this.pageSize = s;
      this.page = 1;
      this.fetchList();
    },
    onReset() {
      this.filterMessageSource = '';
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.isDetail = false;
      this.isEdit = false;
      this.dialogTitle = '新增绑定';
      this.form = emptyForm();
      this.dialogVisible = true;
      this.$nextTick(() => this.reloadChannelPickOptions());
    },
    openEdit(row) {
      this.isDetail = false;
      this.isEdit = true;
      this.dialogTitle = '编辑绑定';
      this.form = {
        id: row.id,
        channelName: row.channelCode || '',
        messageSource: row.messageSource,
        notifyType: row.notifyType != null ? row.notifyType : 0,
        channelId: row.channelId,
        notifyTemplate: row.notifyTemplate || '',
        enabled: row.enabled !== false && row.enabled !== 0,
      };
      this.dialogVisible = true;
      this.$nextTick(() => this.reloadChannelPickOptions());
    },
    async openDetail(row) {
      this.isDetail = true;
      this.isEdit = true;
      this.dialogTitle = '绑定详情';
      try {
        const res = await api.detail(row.id);
        const d = res && res.data ? res.data : {};
        this.form = {
          id: d.id,
          channelName: d.channelCode || '',
          messageSource: d.messageSource,
          notifyType: d.notifyType != null ? d.notifyType : 0,
          channelId: d.channelId,
          notifyTemplate: d.notifyTemplate || '',
          enabled: d.enabled !== false && d.enabled !== 0,
        };
        this.dialogVisible = true;
        this.$nextTick(() => this.reloadChannelPickOptions());
      } catch (e) {
        this.isDetail = false;
      }
    },
    resetForm() {
      this.isDetail = false;
      this.form = emptyForm();
      this.submitLoading = false;
      this.spotSuggestLoading = false;
    },
    scheduleSpotSuggest(forceOverwrite) {
      if (this.isDetail) return;
      if (!this.dialogVisible) return;
      if (!this.canSuggestSpotPlatformTemplate) return;
      if (this.spotSuggestTimer) clearTimeout(this.spotSuggestTimer);
      this.spotSuggestTimer = setTimeout(() => this.pullSpotTemplate(forceOverwrite), 400);
    },
    /** forceOverwrite=true：手动「填入平台模版」；否则仅在模版为空时写入 */
    async pullSpotTemplate(forceOverwrite) {
      if (this.isDetail) return;
      const { messageSource, notifyType } = this.form;
      const channelName = this.form.channelName;
      if (
        !messageSource ||
        (notifyType !== 0 && notifyType !== 1) ||
        channelName === null ||
        channelName === undefined ||
        String(channelName).trim() === ''
      ) {
        return;
      }
      if (!forceOverwrite && this.form.notifyTemplate && String(this.form.notifyTemplate).trim()) {
        return;
      }
      this.spotSuggestLoading = true;
      try {
        const res = await api.spotPlatformTemplateSuggest({
          messageSource,
          notifyType,
          channelId: this.form.channelId,
          channelName: String(channelName).trim(),
        });
        const data = res && res.data;
        if (data && data.matched && data.notifyTemplate != null && data.notifyTemplate !== '') {
          this.form.notifyTemplate = data.notifyTemplate;
        }
      } catch (e) {
        /* empty */
      } finally {
        this.spotSuggestLoading = false;
      }
    },
    submitForm() {
      if (this.isDetail) return;
      this.$refs.form.validate(async (ok) => {
        if (!ok) return;
        this.submitLoading = true;
        try {
          const payload = {
            channelName: this.form.channelName,
            channelId: this.form.channelId,
            messageSource: this.form.messageSource,
            notifyType: this.form.notifyType,
            notifyTemplate: this.form.notifyTemplate || undefined,
            enabled: this.form.enabled,
          };
          if (this.isEdit) {
            payload.id = this.form.id;
            await api.update(payload);
          } else {
            await api.save(payload);
          }
          this.$message.success('保存成功');
          this.dialogVisible = false;
          this.fetchList();
        } catch (e) {
          /* empty */
        } finally {
          this.submitLoading = false;
        }
      });
    },
    confirmDelete(row) {
      this.$confirm('确认删除该绑定？', '提示', { type: 'warning' })
        .then(async () => {
          await api.remove(row.id);
          this.$message.success('已删除');
          this.fetchList();
        })
        .catch(() => {});
    },
    bindingEnabledOn(row) {
      return row.enabled !== false && row.enabled !== 0;
    },
    async onBindingEnabledChange(row, v) {
      try {
        await api.setBindingEnabled(row.id, v);
        row.enabled = v;
        this.$message.success('已更新');
      } catch (e) {
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.toolbar {
  margin-bottom: 12px;
}
.filter-item {
  margin-right: 8px;
}
.pager {
  margin-top: 12px;
  text-align: right;
}
.sub {
  color: #909399;
  font-size: 12px;
}
.tpl-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.tpl-sync {
  align-self: flex-start;
}
</style>
